import React from 'react'
import { Popup } from 'antd-mobile'
import {
  statusLabel,
  weightReps,
  formatTime,
  formatTempo,
  flagsText
} from '../utils/bridgeFormat'
import '../styles/ProgramModal.css'
import '../styles/EditRecommendationModal.css'

const Field = ({ label, value }) => (
  <div className="workout-field">
    <span className="workout-field-label">{label}</span>
    <span className="workout-field-value">{value ?? '—'}</span>
  </div>
)

const FieldRow = ({ children }) => (
  <div className="workout-field-row">{children}</div>
)

function BridgeSetDetailModal({ visible, onClose, record }) {
  if (!record) return null
  const unit = record.weight_unit
  const rxWeightReps =
    weightReps(record.prescribed_weight, record.prescribed_reps, unit) || '—'
  const resultWeightReps =
    weightReps(record.result_weight, record.result_reps, unit) || '—'

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      onClose={onClose}
      position="bottom"
      bodyClassName="modal-popup"
    >
      <div className="modal-content">
        <div className="modal-header-wrapper">
          <div className="modal-header">
            <h2>Workout Set Details</h2>
            <button
              onClick={onClose}
              className="modal-close-btn"
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </div>

        <div className="workout-details-container">
          <FieldRow>
            <Field label="Date" value={record.date_time ? String(record.date_time).split(' ')[0] : '—'} />
            <Field label="Status" value={statusLabel(record.status) || '—'} />
          </FieldRow>

          <FieldRow>
            <Field label="Program" value={record.program_name || '—'} />
            <Field label="Phase" value={record.phase_name || '—'} />
          </FieldRow>

          <FieldRow>
            <Field label="Workout" value={record.workout_name || '—'} />
            <Field label="Exercise" value={record.exercise_name || '—'} />
          </FieldRow>

          <FieldRow>
            <Field label="Set" value={record.sequence ?? '—'} />
            <Field label="Set Type" value={record.set_type || '—'} />
          </FieldRow>

          <FieldRow>
            <Field label="Rx Weight/Reps" value={rxWeightReps} />
            <Field label="Result Weight/Reps" value={resultWeightReps} />
          </FieldRow>

          <FieldRow>
            <Field label="Rx Time" value={formatTime(record.prescribed_time_ms) || '—'} />
            <Field label="Result Time" value={formatTime(record.result_time_ms) || '—'} />
          </FieldRow>

          <FieldRow>
            <Field label="Rx Tempo" value={formatTempo(record.prescribed_tempo) || '—'} />
            <Field label="Result Tempo" value={formatTempo(record.result_tempo) || '—'} />
          </FieldRow>

          <FieldRow>
            <Field
              label="Rest"
              value={record.rest_time != null ? `${record.rest_time}s` : '—'}
            />
            <Field
              label="Round"
              value={record.round_number == null ? '—' : record.round_number}
            />
          </FieldRow>

          <FieldRow>
            <Field label="Flags" value={flagsText(record) || '—'} />
            <Field label="Note" value={record.note || '—'} />
          </FieldRow>
        </div>
      </div>
    </Popup>
  )
}

export default BridgeSetDetailModal
